/**
 * Sync product-gallery main image when product-info fires pi:variant-change.
 */
(function () {
  function resolveVariantImage(variant, product) {
    if (!variant) return null;

    if (variant.featured_image?.src) return variant.featured_image.src;
    if (variant.featured_media?.preview_image?.src) return variant.featured_media.preview_image.src;

    const mediaList = product.media || product.images || [];
    for (const media of mediaList) {
      const ids = media.variant_ids || [];
      if (ids.includes(variant.id)) {
        return media.preview_image?.src || media.src || null;
      }
    }

    return null;
  }

  function updateGallery(gallery, variant) {
    const jsonEl = gallery.querySelector('[data-pi-product-json]');
    if (!jsonEl) return;

    let product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch {
      return;
    }

    const src = resolveVariantImage(variant, product);
    if (!src) return;

    const main =
      gallery.querySelector('[data-pi-gallery-main]') ||
      gallery.querySelector('.product-gallery__main-image') ||
      gallery.querySelector('.pg-main-image') ||
      gallery.querySelector('.pet-gallery__main-image') ||
      gallery.querySelector('[id^="main-image-"]') ||
      gallery.querySelector('[id^="pg-main-img-"]') ||
      gallery.querySelector('[id^="gallery-image-"]');

    if (!main) return;

    const switchingClass =
      main.classList.contains('product-gallery__main-image') ? 'product-gallery__main-image--switching' : 'switching';

    main.classList.add(switchingClass);
    setTimeout(() => {
      main.src = src;
      if (main.srcset !== undefined) {
        main.removeAttribute('srcset');
      }
      main.classList.remove(switchingClass);
    }, 200);

    const thumbs = gallery.querySelectorAll(
      '[data-pi-gallery-thumb], .product-gallery__thumb, .pg-thumb, .pg-thumb-wrap',
    );
    thumbs.forEach((t) => t.classList.remove('active', 'is-active', 'product-gallery__thumb--active'));

    const normalized = src.split('?')[0];
    thumbs.forEach((thumb) => {
      const img = thumb.tagName === 'IMG' ? thumb : thumb.querySelector('img');
      if (!img) return;
      const thumbSrc = (img.currentSrc || img.src || '').split('?')[0];
      if (thumbSrc && normalized.includes(thumbSrc.split('/').pop())) {
        thumb.classList.add('active', 'is-active', 'product-gallery__thumb--active');
      }
    });
  }

  document.addEventListener('pi:variant-change', (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    document.querySelectorAll('[data-pi-product-gallery]').forEach((gallery) => {
      updateGallery(gallery, variant);
    });
  });
})();
